import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import Process from './Process';
import PageIntroBanner from '../../components/PageIntroBanner';

const styles = css`
  main {
    padding:20px 0;
    @media (min-width: 480px) {
      padding:40px 0;
    }
    @media (min-width: 768px) {
      padding:60px 0;
    }
  }
`;

function OurProcess({ page }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuAbout />
        <PageIntroBanner
          heading={get(page, 'page_intro_banner[0].heading')}
          body={get(page, 'page_intro_banner[0].text')}
          image={get(page, 'page_intro_banner[0].image.contentUrl')}
        />
        <main>
          <Process page={page} />
        </main>
      </PageWrapper>
    </div>
  );
}

OurProcess.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'homebuilding_process',
})(OurProcess);



// WEBPACK FOOTER //
// ./src/pages/HomebuildingProcess/index.js